import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import SearchPartnerById from './SearchById'

export default function index() {
  return (
    <div>
        <Header/>
        <SearchPartnerById/>
        <Footer/>
    </div>
  )
  
}
